import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { ToolbarComponent } from '../components/toolbar/toolbar.component';

@Component({
  selector: 'dime-admin-layout',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, ToolbarComponent],
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent {
  readonly sidebarCollapsed = signal(false);

  onMenuToggle(): void {
    this.sidebarCollapsed.update((v) => !v);
  }
}
